

export class NavigationButton {
    id: string;
    title: string;
    buttonFunction: string;
    iconClass: string;
    enable: boolean;
    stateOpen: boolean;
}
